module.exports = __webpack_public_path__ + "static/integrations-lawyers-mobile-f02933aed11688969e05f4f5f02d6d27.png";